// - - - - - - - - - -
// crewScoreLabel — the crew cell's LTR line (#695, Leland 2026-10-15).
//
// "fYTD (25) 92%" (Leland 2026-10-16: fiscal year to date, 1/31 → 1/30; one stat; the
// survey count in parentheses — the same calculation as FlooringXP: the share of the crew's
// surveys answering 9–10 to "how likely are you to recommend"). No surveys this fiscal year →
// null (no line). Earlier the same day: "yr (25) 92%" (last 52 weeks).
// - - - - - - - - - -

const pct = (x) => `${Math.round(x * 100)}%`;

/** score = { w4, w52, fytd: { ltr, n } } from scheduler/crewScores:ltrForCrews. */
export function formatCrewLtrLine(score) {
  const f = score && score.fytd;
  if (!f || typeof f.ltr !== "number" || !(f.n > 0)) return null;
  return `fYTD (${f.n}) ${pct(f.ltr)}`;
}

/** The grid's crews as the sorted, de-duplicated payroll list the query takes (stable args). */
export function crewPayrollList(candidates, formatPayroll) {
  const out = new Set();
  for (const c of candidates || []) {
    const p = c && c.payrollNo != null ? formatPayroll(c.payrollNo) : "";
    if (p) out.add(p);
  }
  return [...out].sort();
}
